import React from "react";
import { AutoComplete, Col, DatePicker, Form, Input, InputNumber, Row, Select } from "antd";

const CURRENCY_OPTIONS = ["RUB", "USD", "EUR", "CNY", "MNT"].map((item) => ({
    label: item,
    value: item,
}));

/**
 * The Ханш field set, shared by manual entry and the edit modal so both forms stay identical in
 * layout and validation.
 *
 * Institution is a free-text AutoComplete seeded with the values already in the table, so a new
 * institution can be typed while the usual ones stay one click away.
 */
function RateFormFields({ t, institutionOptions = [] }) {
    return (
        <Row gutter={[16, 0]}>
            <Col xs={24} md={12}>
                <Form.Item
                    label={t("col.name")}
                    name="name"
                    rules={[
                        { required: true, message: t("rate.req.name") },
                        { max: 255, message: t("req.max255") },
                    ]}
                >
                    <Input placeholder={t("rate.manual.ph.name")} allowClear />
                </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={6}>
                <Form.Item
                    label={t("col.currency")}
                    name="currency"
                    rules={[{ required: true, message: t("req.currency") }]}
                >
                    <Select
                        placeholder={t("col.currency")}
                        options={CURRENCY_OPTIONS}
                        showSearch
                        allowClear
                    />
                </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={6}>
                <Form.Item
                    label={t("col.rate")}
                    name="rate"
                    rules={[
                        { required: true, message: t("rate.req.rate") },
                        { type: "number", min: 0.0001, message: t("rate.req.ratePositive") },
                    ]}
                >
                    <InputNumber
                        style={{ width: "100%" }}
                        placeholder="0.00"
                        min={0.0001}
                        step={0.01}
                    />
                </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8}>
                <Form.Item
                    label={t("col.institution")}
                    name="institution"
                    rules={[{ max: 100, message: t("rate.req.max100") }]}
                >
                    <AutoComplete
                        placeholder={t("rate.manual.ph.institution")}
                        options={institutionOptions.map((item) => ({ value: item }))}
                        filterOption={(input, option) =>
                            String(option?.value || "")
                                .toLowerCase()
                                .includes(String(input || "").toLowerCase())
                        }
                        allowClear
                    />
                </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8}>
                <Form.Item
                    label={t("col.amount")}
                    name="amount"
                    rules={[
                        { required: true, message: t("req.amount") },
                        { type: "number", min: 0.01, message: t("req.amountPositive") },
                    ]}
                >
                    <InputNumber
                        style={{ width: "100%" }}
                        placeholder="0.00"
                        precision={2}
                        min={0.01}
                        step={0.01}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        parser={(value) => `${value}`.replace(/,/g, "")}
                    />
                </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8}>
                <Form.Item label={t("col.executedDate")} name="executedDate">
                    <DatePicker
                        style={{ width: "100%" }}
                        format="YYYY-MM-DD"
                        placeholder={t("manual.ph.date")}
                    />
                </Form.Item>
            </Col>
        </Row>
    );
}

export default RateFormFields;
